import { render, staticRenderFns } from "./PedidoForm.vue?vue&type=template&id=218a17e7&scoped=true&"
import script from "./PedidoForm.vue?vue&type=script&lang=js&"
export * from "./PedidoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218a17e7",
  null
  
)

export default component.exports